var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 85,
    viewBox: "0 0 97 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2696 8.91314C85.2696 9.91485 84.4593 10.7355 83.4473 10.7355C82.4333 10.7355 81.625 9.92717 81.625 8.91314C81.625 7.8991 82.4333 7.09082 83.4473 7.09082C84.4613 7.09082 85.2696 7.8991 85.2696 8.91314Z",
    stroke: "#20ACE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3634 8.91314C77.3634 9.91485 76.5531 10.7355 75.5411 10.7355C74.527 10.7355 73.7188 9.92717 73.7188 8.91314C73.7188 7.8991 74.527 7.09082 75.5411 7.09082C76.5551 7.09082 77.3634 7.8991 77.3634 8.91314Z",
    stroke: "#20ACE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4181 8.91314C69.4181 9.91485 68.6078 10.7355 67.5958 10.7355C66.5817 10.7355 65.7734 9.92717 65.7734 8.91314C65.7734 7.8991 66.5817 7.09082 67.5958 7.09082C68.6098 7.09082 69.4181 7.8991 69.4181 8.91314Z",
    stroke: "#20ACE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.8262V4.85619C1 2.72024 2.73457 1 4.8562 1H92.1295C94.2655 1 95.9857 2.73457 95.9857 4.85619V16.8262",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 67.6735V16.8262H96V34.1576",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32.5225V80.1443C96 82.2803 94.2655 84.0005 92.1438 84.0005H4.8562C2.72024 84.0005 1 82.266 1 80.1443V66.4684",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8488 50.4277H56.4062",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5297 59.689V77.8375H32.1016V50.4141H57.1883",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 71.6606L43.6974 57.3683C43.8121 57.096 44.1992 57.096 44.2995 57.3683L49.6896 71.675",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9766 68.1035H48.0617",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0426 63.4853C75.0426 63.4853 73.4084 62.1091 71.4875 62.6968C69.7242 63.2272 69.4805 65.2628 70.7563 66.0943C70.7563 66.0943 72.0035 66.6534 73.394 67.1694C76.7342 68.4023 75.3006 71.642 72.6056 71.642C69.9106 71.642 70.1256 71.0543 69.4375 70.2945",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5547 58.0117V71.6446",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5678 67.073C63.5678 69.596 61.5178 71.6459 58.9948 71.6459C56.4718 71.6459 54.4219 69.596 54.4219 67.073C54.4219 64.55 56.4718 62.5 58.9948 62.5C61.5178 62.5 63.5678 64.55 63.5678 67.073Z",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1947 50.9997C90.1947 55.802 86.3098 59.6869 81.5075 59.6869C76.7052 59.6869 72.8203 55.802 72.8203 50.9997C72.8203 46.1974 76.7052 42.3125 81.5075 42.3125C86.3098 42.3125 90.1947 46.1974 90.1947 50.9997Z",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7422 52.7798L81.5198 51.0022L83.2973 49.2246",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7422 49.2246L81.5198 51.0022L83.2973 52.7798",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 23.0059H77.2606V29.1844H19.7188V23.0059Z",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3819 44.2461H7.17969",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7031 38.0723H57.3872",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17969 50.4277H25.9016",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9016 56.6074H7.17969",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 62.7852H7.17969",
    stroke: "#20ACE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPub);
export default __webpack_public_path__ + "static/media/pub.b3a8df35d27838c04cc2754f465ee058.svg";
export { ForwardRef as ReactComponent };